/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Merge_DownInputs */

const en_shortcut_keys_desc_merge_down = /** @type {(inputs: Shortcut_Keys_Desc_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge the selected Event with the next Event.`)
};

const fr_shortcut_keys_desc_merge_down = /** @type {(inputs: Shortcut_Keys_Desc_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner l'evenement selectionne avec l'evenement suivant.`)
};

const de_shortcut_keys_desc_merge_down = /** @type {(inputs: Shortcut_Keys_Desc_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ausgewählte Ereignis wird mit dem nächsten Ereignis zusammengeführt.`)
};

const it_shortcut_keys_desc_merge_down = /** @type {(inputs: Shortcut_Keys_Desc_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci l'evento selezionato con l'evento successivo.`)
};

const ru_shortcut_keys_desc_merge_down = /** @type {(inputs: Shortcut_Keys_Desc_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединить выбранное событие со следующим событием.`)
};

const es_shortcut_keys_desc_merge_down = /** @type {(inputs: Shortcut_Keys_Desc_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar el evento seleccionado con el siguiente evento.`)
};

const zh_cn2_shortcut_keys_desc_merge_down = /** @type {(inputs: Shortcut_Keys_Desc_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将选定的事件与下一个事件合并。`)
};

const ja_shortcut_keys_desc_merge_down = /** @type {(inputs: Shortcut_Keys_Desc_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントを次のイベントと結合します。`)
};

const hi_shortcut_keys_desc_merge_down = /** @type {(inputs: Shortcut_Keys_Desc_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट को अगले इवेंट के साथ मर्ज करें।`)
};

const pt_pt2_shortcut_keys_desc_merge_down = /** @type {(inputs: Shortcut_Keys_Desc_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combine o evento selecionado com o próximo evento.`)
};

/**
* | output |
* | --- |
* | "Merge the selected Event with the next Event." |
*
* @param {Shortcut_Keys_Desc_Merge_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_merge_down = /** @type {((inputs?: Shortcut_Keys_Desc_Merge_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Merge_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_merge_down(inputs)
	if (locale === "de") return de_shortcut_keys_desc_merge_down(inputs)
	if (locale === "it") return it_shortcut_keys_desc_merge_down(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_merge_down(inputs)
	if (locale === "es") return es_shortcut_keys_desc_merge_down(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_merge_down(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_merge_down(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_merge_down(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_merge_down(inputs)
	return en_shortcut_keys_desc_merge_down(inputs)
});